<!-- <ion-content> -->
<ion-content>
  <div class="attr_div bg_content">
    <div class="d__flex just-s header__ background_white">
      <h5 class="header m-0">Edit Variants</h5>
      <ion-icon (click)="modalCtrl.dismiss()" name="close-outline"></ion-icon>
    </div>
    <div class="attribute-edit-container">
      <ion-list *ngIf="product_info.variant_combination && product_info.variant_combination.length != 0" class="p0" lines="none">
        <div *ngFor="let data of product_info.variant_combination; let index = index;">
          <ion-item lines="none" *ngIf="edit_index ? edit_index == (index + 1): true" class="bb">
            <ion-thumbnail *ngIf="edit_index ? edit_index == (index + 1): true" slot="start">
              <img src="assets/no-product.svg">
              <!-- <img *ngIf="data.image" (click)="edit_img('variants',index)" [src]="data.image"> -->
              <!-- <div *ngIf="!data.image" class="_addimg" (click)="edit_img('variants',index)">
                <ion-icon name="add-outline"></ion-icon>
              </div> -->
              <!-- <img *ngIf="data.image == null" src="..." (click)="edit_img('variants')" src="..."> -->
            </ion-thumbnail>
            <ion-label class="w100">
              <h6 *ngIf="data.option_value">Option: {{data.option_value}}</h6>
              <p *ngIf="data.attribute_html" class="mb0 inner_html" [innerHtml]="data.attribute_html"></p>
              <ion-button class="del_btn" size="small" fill="clear" (click)="del_options(data,index,product_info.variant_combination)" color="danger">
                <ion-icon color="danger" src="assets/icons/delete.svg"></ion-icon>
              </ion-button>
              <div class="d__flex gap-10 align-c mt10">
                <div class="price_div">
                  <ion-label class="m-0 input_label custom_label">Weight (In KG)</ion-label>
                  <ion-input #price type="number" min="0" [(ngModel)]="data.weight" (ionFocus)="select_value($event)" (ionBlur)="getPrice($event,data,'old')"></ion-input>
                </div>
                <div class="uom_div">
                  <ion-label class="m-0 input_label lable_floating">UOM</ion-label>
                  <ion-select class="p0 order_type_info form-input-select" interface="popover" name="data.uom" [(ngModel)]="data.uom" [ngModelOptions]="{standalone: true}">
                    <ion-select-option *ngFor="let item of uom" value="{{item.name}}">{{item.name}}</ion-select-option>
                  </ion-select>
                  <!-- <ion-input #price type="number" min="0" [(ngModel)]="data.weight" (ionFocus)="select_value($event)" (ionBlur)="getPrice($event,data,'old')"></ion-input> -->
                </div>
                <!-- <div *ngIf="data.sku" class="price_div">
                  <ion-label class="m-0 input_label custom_label">SKU</ion-label>
                  <ion-input [disabled]="true" type="text" [(ngModel)]="data.sku" (ionFocus)="select_value($event)"></ion-input>
                </div> -->
              </div>
              <div *ngIf="false" class="d__flex">
                <p class="flex50">Price</p>
                <p class="flex50">Stock</p>
              </div>
              <div *ngIf="false" class="d__flex">
                <!-- <ion-input class="input_class flex50" type="number" [(ngModel)]="data.price"></ion-input> -->
                <div class="cart__button ion-activatable ripple-parent position-relative">
                  <ion-button (click)="data.stock = minus(data.stock)" class="mouse __button" fill="clear"><span>-</span></ion-button>
                  <div class="d__flex gap-5">
                    <span class="add__txt"> {{data.stock ? data.stock : 0}} </span>
                  </div>
                  <ion-button class="mouse __button" (click)="data.stock = pluscount(data.stock)" fill="clear"><span>+</span></ion-button>
                </div>
                <!-- <ion-input class="input_class" type="number" [(ngModel)]="data.stock"></ion-input> -->
              </div>
            </ion-label>
          </ion-item>
        </div>
        <div class="mb55"></div>
      </ion-list>
      <!-- <div class="myform" *ngIf="current_variant">
    <div *ngFor="let item of form_data[0].group_fileds">
      <div [title]="item.name" class="m-0 label position-relative d__flex ion-align-items-center" (mouseenter)="item.show_info = true" (mouseleave)="item.show_info = false" (click)="item.input_type == 'checkbox' ?item.value = !item.value:null">
        <span class="op-7"> {{item.label}} </span>
      </div>
      <ion-input *ngIf="item.input_type == 'input'" [name]="item.name" [type]="item.type" [(ngModel)]="current_variant[item.name]" [placeholder]="item.placeholder" [required]="item.required" [email]="item.validator == 'email'" [pattern]="item.pattern" [value]="item.value" (ionFocus)="item.focus = true" (ionBlur)="item.focus = false" [class.focus]="item.focus"></ion-input>
      <ion-checkbox *ngIf="item.input_type == 'checkbox'" [name]="item.name" [required]="current_variant[item.name]" [value]="item.value" [checked]="item.value" [(ngModel)]="item.value"></ion-checkbox>
    </div>
  </div>
  <div class="attribute_table">
    <div class="d__flex attribute-row">
      <div>Option</div>
      <div>Display Order</div>
      <div>Is Pre Selected</div>
      <div>Disable</div>
      <div>Actions</div>
    </div>
    <div class="d__flex attribute-row" *ngFor="let item of current_attribute.options">
      <div>{{item.option_value}}</div>
      <div>{{item.display_order}}</div>
      <div>{{item.is_pre_selected}}</div>
      <div>0</div>
      <div>
        <ion-button fill="clear" class="ion-text-capitalize" color="success" size="small" (click)="load_values(current_attribute.options)">Edit</ion-button>
        <ion-button fill="clear" class="ion-text-capitalize" color="danger" size="small">Delete</ion-button>
      </div>
    </div>
  </div> -->
    </div>
    <div class="buttons__">
      <ion-button expand="block" (click)="save_data()" class="save_b">Save</ion-button>
    </div>
  </div>
</ion-content>
<!-- <ion-footer>
  <ion-toolbar>
    <ion-button expand="block" (click)="save_data()" class="save_b">Save</ion-button>
  </ion-toolbar>
</ion-footer> -->
